import { observer } from "mobx-react-lite";
import React, { useRef } from "react";

import { ClaimsScreenContext } from "@modules/acc/screens/claims/context/ClaimsScreenContext.ts";
import { ClaimsScreenHelper } from "@modules/acc/screens/claims/context/ClaimsScreenHelper.ts";
import { useStores } from "@stores/hooks/useStores.ts";

import { ClaimsFilter } from "./components/claims-filter/ClaimsFilter.tsx";
import { ClaimsList } from "./components/ClaimsList.tsx";
import { ClaimsListCard } from "./components/ClaimsListCard.tsx";
import { NewClaimButtonsGroup } from "./components/NewClaimButtonsGroup.tsx";

const ClaimsScreenBase: React.FC = observer(() => {
  return (
    <ClaimsListCard heading="Claims" button={<NewClaimButtonsGroup />}>
      <ClaimsFilter>
        <ClaimsList />
      </ClaimsFilter>
    </ClaimsListCard>
  );
});

const ClaimsScreen: React.FC = () => {
  const root = useStores();
  const claimsScreenHelper = useRef(new ClaimsScreenHelper(root));

  return (
    <ClaimsScreenContext.Provider value={claimsScreenHelper.current}>
      <ClaimsScreenBase />
    </ClaimsScreenContext.Provider>
  );
};

// ⚠ It should be exported as default since it is used for React.lazy
// eslint-disable-next-line import/no-default-export
export default ClaimsScreen;
